import controller from './rating.contoller';
import template from './rating.html';

const ratingComponent = {
	bindings: {
		ratingSize: '<',
		ratingSelected: '<',
		isReadOnly: '<',
		selectRating: '&'
	},
	controller,
	template,
};

export default ratingComponent;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/rating/rating.component.js